import React from 'react';
import { Link } from 'react-router-dom';


const NotFound404 = () => (
  <div className="not-found">
    <div className="not-found__content">
        <h3>Sorry, We couldn’t find the page you’re looking for! </h3>
      <Link className="btn btn-primary" to="/">Back Home</Link>
    </div>
  </div>
);

export default NotFound404;
